import { QueryFactory } from "../../../../Common";
export const QGetFreespins = QueryFactory("GetFreespins");
//# sourceMappingURL=QGetFreespins.js.map